import { render, staticRenderFns } from "./BrandMediaCard.vue?vue&type=template&id=689bab84&scoped=true&"
import script from "./BrandMediaCard.vue?vue&type=script&lang=ts&"
export * from "./BrandMediaCard.vue?vue&type=script&lang=ts&"
import style0 from "./BrandMediaCard.vue?vue&type=style&index=0&id=689bab84&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689bab84",
  null
  
)

export default component.exports